import "./PopupOne.css";
import robotImg from '../../../images/robotImg.png'
import { useLanguage } from "../../../Providers/LanguageContext";
import toast from "react-hot-toast";
import { useUserData } from "../../../Providers/UserWrapper";
import HttpClient from "../../../utils/HttpClient";
import { useRef, useState, useEffect } from "react";

export default function PopupOne({ formData, setFormData, onClose, onNext, handleSaveOnDB }) {
  const { language } = useLanguage();
  const { setIsLoading } = useUserData();
  const [iconPreview, setIconPreview] = useState("");
  const [logoPreview, setLogoPreview] = useState("");
  const iconInputRef = useRef(null);
  const logoInputRef = useRef(null);

  // Initialize previews from formData
  useEffect(() => {
    if (formData.icon) setIconPreview(formData.icon);
    if (formData.logo) setLogoPreview(formData.logo);
  }, []);

  const handleImageUpload = async (file, type) => {
    if (!file) return;

    // Basic validation for file type
    if (!file.type.includes('image/png')) {
      toast.error("Please upload a PNG image");
      return;
    }

    // Basic validation for dimensions (client-side check)
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = async () => {
      // if (type === 'icon') {
      //   if (img.width !== 512 || img.height !== 512) {
      //     toast.error("Icon must be 512×512 pixels");
      //     URL.revokeObjectURL(objectUrl);
      //     return;
      //   }
      // } else if (type === 'logo') {
      //   if (img.width !== 1000 || img.height !== 800) {
      //     toast.error("Logo must be 1000×800 pixels");
      //     URL.revokeObjectURL(objectUrl);
      //     return;
      //   }
      // }

      // Set preview immediately
      if (type === 'icon') {
        setIconPreview(objectUrl);
      } else {
        setLogoPreview(objectUrl);
      }

      // Upload to server
      setIsLoading(true);
      try {
        const formDataToSend = new FormData();
        formDataToSend.append('image', file);

        const response = await HttpClient.fileUplode(
          'upload',
          'POST',
          formDataToSend
        );

        if (response && response.status) {
          setFormData(prev => ({
            ...prev,
            [type]: response.data.url,
          }));
          toast.success(`${type.charAt(0).toUpperCase() + type.slice(1)} uploaded successfully!`);
        } else {
          toast.error(response?.message || `Failed to upload ${type}`);
          // Remove preview on failure
          if (type === 'icon') {
            setIconPreview("");
            setFormData(prev => ({ ...prev, icon: "" }));
          } else {
            setLogoPreview("");
            setFormData(prev => ({ ...prev, logo: "" }));
          }
        }
      } catch (error) {
        console.error(`Error uploading ${type}:`, error);
        toast.error(`Error uploading ${type}`);
        // Remove preview on error
        if (type === 'icon') {
          setIconPreview("");
          setFormData(prev => ({ ...prev, icon: "" }));
        } else {
          setLogoPreview("");
          setFormData(prev => ({ ...prev, logo: "" }));
        }
      } finally {
        setIsLoading(false);
        // Clear file input
        if (type === 'icon' && iconInputRef.current) {
          iconInputRef.current.value = '';
        } else if (type === 'logo' && logoInputRef.current) {
          logoInputRef.current.value = '';
        }
      }
    };

    img.src = objectUrl;
  };

  const handleIconUpload = (e) => {
    const file = e.target.files[0];
    handleImageUpload(file, 'icon');
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    handleImageUpload(file, 'logo');
  };

  const handleDeleteImage = (type) => {
    if (type === 'icon') {
      setIconPreview("");
      setFormData(prev => ({ ...prev, icon: "" }));
      if (iconInputRef.current) iconInputRef.current.value = '';
      toast.success("Icon removed");
    } else {
      setLogoPreview("");
      setFormData(prev => ({ ...prev, logo: "" }));
      if (logoInputRef.current) logoInputRef.current.value = '';
      toast.success("Logo removed");
    }
  };

  const handleUrlChange = (e) => {
    setFormData(prev => ({
      ...prev,
      url: e.target.value
    }));
  };

  const handleCopyUrl = () => {
    if (formData.url) {
      navigator.clipboard.writeText(formData.url);
      toast.success("URL copied to clipboard!");
    } else {
      toast.error("No URL to copy");
    }
  };

  const handleEditUrl = () => {
    // Focus on URL input for editing
    const urlInput = document.querySelector('.url_input_po input');
    if (urlInput) urlInput.focus();
  };

  const handleDeleteUrl = () => {
    setFormData(prev => ({
      ...prev,
      url: ""
    }));
    toast.success("URL cleared");
  };

  const handleSaveAndNext = () => {
    // Optional: Add validation here if needed
    handleSaveOnDB(formData);
    // toast.success("Your data has been saved successfully");
    onNext();
  };

  return (
    <div className="popup_overlay_po" onClick={onClose}>
      <div
        className="popup_container_po"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="popup_content_po">

          <div className="popup_left_po">
            <div className="mob_rob_wrp">
              <h2>
                <span>{language?.hi_word}!</span> {language?.user_guide_modal_main_title}
              </h2>
              <div className="robo_img_wrp">
                <img src={robotImg} alt="" />
              </div>
            </div>

            <div className="step_pill_po">{language.step_1_user_personalized}</div>

            <p className="upload_label">Upload Your Icon (png) 512×512</p>
            <div className="upload_box_po">
              <input
                type="file"
                accept="image/png"
                onChange={handleIconUpload}
                ref={iconInputRef}
                style={{ display: 'none' }}
                id="icon-upload"
              />
              <label htmlFor="icon-upload" className="upload_inner_po">
                {iconPreview ? (
                  <div className="image-preview-container">
                    <img
                      src={iconPreview}
                      alt="Icon preview"
                      className="image-preview"
                    />
                  </div>
                ) : (
                  <>
                    <i className="fa-solid fa-cloud-arrow-up"></i>
                    <span>BROWSE</span>
                  </>
                )}
              </label>

              {iconPreview && (
                <i
                  className="fa-solid fa-trash upload_trash_po"
                  onClick={() => handleDeleteImage('icon')}
                  style={{ cursor: 'pointer' }}
                ></i>
              )}
            </div>

            <p className="upload_label">Upload Your Logo (png) 1000×800</p>
            <div className="upload_box_po">
              <input
                type="file"
                accept="image/png"
                onChange={handleLogoUpload}
                ref={logoInputRef}
                style={{ display: 'none' }}
                id="logo-upload"
              />
              <label htmlFor="logo-upload" className="upload_inner_po">
                {logoPreview ? (
                  <div className="image-preview-container">
                    <img
                      src={logoPreview}
                      alt="Logo preview"
                      className="image-preview"
                    />
                  </div>
                ) : (
                  <>
                    <i className="fa-solid fa-cloud-arrow-up"></i>
                    <span>BROWSE</span>
                  </>
                )}
              </label>

              {logoPreview && (
                <i
                  className="fa-solid fa-trash upload_trash_po"
                  onClick={() => handleDeleteImage('logo')}
                  style={{ cursor: 'pointer' }}
                ></i>
              )}
            </div>

            <div className="url_box_po">
              <p>Customize Your URL</p>

              <div className="url_input_po">
                <input
                  placeholder="https:// Enter Name /fisibility.com"
                  value={formData.url}
                  onChange={handleUrlChange}
                />
                <i
                  className="fa-regular fa-copy"
                  onClick={handleCopyUrl}
                  style={{ cursor: formData.url ? 'pointer' : 'not-allowed', opacity: formData.url ? 1 : 0.5 }}
                ></i>
                <i
                  className="fa-solid fa-pen"
                  onClick={handleEditUrl}
                  style={{ cursor: 'pointer' }}
                ></i>
                <i
                  className="fa-solid fa-trash"
                  onClick={handleDeleteUrl}
                  style={{ cursor: formData.url ? 'pointer' : 'not-allowed', opacity: formData.url ? 1 : 0.5 }}
                ></i>
              </div>
            </div>

            <button className="save_next_po" onClick={handleSaveAndNext}>
              SAVE & NEXT
            </button>

            <p className="skip_po" onClick={onNext}>
              Skip to next
            </p>
          </div>
        </div>
      </div>
      <div className="popup_right_po">
        <img
          src={robotImg}
          alt="robot"
          className="robot_img_po"
        />
      </div>
    </div>
  );
}